import * as Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import merge from 'lodash/fp/merge';
import cloneDeep from 'lodash/fp/cloneDeep';
import * as constants from '@adc/constants';
import * as common from './common';
import { usesProxy, generateProxyRoute } from './proxyRoutes';
const getProgressErrorMessage = (responseText) => {
    let message = '';
    try {
        const parsedResponse = responseText.length > 0 ? JSON.parse(responseText) : {};
        message = parsedResponse === null || parsedResponse === void 0 ? void 0 : parsedResponse.message;
    }
    catch (parseError) { }
    return message;
};
const defaultProgressOptions = Object.freeze({
    method: 'get',
    isUpload: false,
    headers: {
        Accept: 'application/json',
    },
    queryParams: {},
});
export default function (url, passedOptions = {}) {
    let options = merge(cloneDeep(defaultProgressOptions), passedOptions);
    options.headers[constants.headers.CORRELATION_HEADER] = uuidv4();
    if (usesProxy(url)) {
        url = generateProxyRoute(url).route;
    }
    const xsrfValue = Cookies.get(constants.cookies.XSRF_COOKIE);
    if (xsrfValue) {
        ;
        options.headers[constants.headers.XSRF_HEADER] =
            xsrfValue;
    }
    return new Promise(function (resolve, reject) {
        const xhr = new window.XMLHttpRequest();
        let params = new URLSearchParams(common.serializeParams(options.queryParams || {}));
        url = common.constructUrl(url, options.queryParams);
        xhr.open(options.method, url);
        xhr.responseType = options.responseType || xhr.responseType;
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                const body = typeof xhr.response === 'string'
                    ? JSON.parse(xhr.response)
                    : xhr.response;
                resolve({
                    status: this.status,
                    body,
                });
            }
            else {
                reject({
                    status: this.status,
                    body: xhr.statusText,
                    message: getProgressErrorMessage(xhr.responseText),
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                body: xhr.statusText,
                message: getProgressErrorMessage(xhr.responseText),
            });
        };
        xhr.upload.onprogress = e => {
            if (e.lengthComputable) {
                const percentage = Math.round((e.loaded / e.total) * 100);
                if (options.onProgress)
                    options.onProgress(percentage);
            }
        };
        if (options.headers) {
            Object.entries(options.headers).forEach(([key, val]) => {
                xhr.setRequestHeader(key, val);
            });
        }
        if (typeof Blob !== 'undefined' && options.body instanceof Blob) {
            params = options.body;
        }
        else if (options.isUpload) {
            params = new window.FormData();
            Object.entries(options.body).forEach(([key, val]) => {
                if (key === 'file' && typeof val === 'object') {
                    ;
                    params.append(key, val, name);
                }
                else {
                    ;
                    params.append(key, val);
                }
            });
        }
        xhr.send(params);
    });
}
//# sourceMappingURL=withProgress.js.map